<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-layout mb-1>
      <v-flex xs12>
        <h2 class="white--text">NCE Reports</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3> </v-flex>
      <v-spacer> </v-spacer>
      <v-col cols="12" md="2" class="text-lg-right">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn  @click="exportToExcel" color="secondary" dark v-on="on"> Export Report </v-btn>
          </template>
        </v-menu>
      </v-col>
    </v-layout>
    <v-layout row wrap ml-3>
      <v-flex  fluid fill-height>
        <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="7">
        <v-card raised height="380" width="800" class="right-aligned-chart-item">
          <DxPieChart
            id="pie"
            :data-source="transactions"
            palette="Bright"
            title="Paid and Pending Payments Report"
            @point-click="pointClickHandler($event)"
            @legend-click="legendClickHandler($event)"
            class="right-aligned-chart-item"
          >
            <DxSeries argument-field="transaction" value-field="eslip" name="transaction" class="right-aligned-chart">
              <DxLabel :visible="true">
                <DxConnector :visible="true" :width="1" />
              </DxLabel>
            </DxSeries>
            <DxSize :width="500" />
            <DxExport :enabled="true" />
          </DxPieChart>
        </v-card>
      </v-col>
      </v-row>
      </v-flex>
    </v-layout>
    <v-layout mt-200>
      <v-flex xs12 mt-200>
        <PaidUnpaidData v-show="showTranType"  :segmentSelected="segmentSelected" :key="childComponentKey" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import config from "../../../config";
import PaidUnpaidData from "./PaidUnpaidData";
import { mapActions } from "vuex";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import DxPieChart, {
  DxSize,
  DxSeries,
  DxLabel,
  DxConnector,
  DxExport,
} from "devextreme-vue/pie-chart";

export default {
  name: "PaidAndPendingPaymentsRpts",
  components: {
    PaidUnpaidData,
    DxPieChart,
    DxSize,
    DxSeries,
    DxLabel,
    DxConnector,
    DxExport,
  },
  data: function () {
    return {
      message: "",
      snackbar: false,
      snackbarColor: "",
      showTranType: false,
      items: [{ name: "auction", title: "Auction File", ext: "xlsx" }],
      deadline: "",
      paymentSettlements: [],
      paidTxns: 0,
      failedTxns: 0,
      pendingTxns: 0,
      segmentSelected: null,
      childComponentKey: 0,

      transactions: [
        {
          transaction: "Paid Transactions",
          eslip: 0,
          trantype: "PAID",
        },
        {
          transaction: "Pending Transactions",
          eslip: 0,
          trantype: "PENDING",
        },
        {
          transaction: "Failed Transactions",
          eslip: 0,
          trantype: "FAILED",
        },
      ],
    };
  },
  mounted() {
    this.getPaymentsDetails();
  },
  computed: {
    todaysDate: function () {
      const now = new Date();
      const options = {
        day: "numeric",
        month: "short",
        weekday: "long",
        year: "numeric",
      };
      return now.toLocaleString("en-us", options);
    },
  },
  methods: {
    exportToExcel() {
      const jsonData =  this.paymentSettlements;

      // Convert JSON array to worksheet
      const ws = XLSX.utils.json_to_sheet(jsonData);

      // Create a workbook and add the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Coffee-DSS-Report");

      // Save the Excel file
      XLSX.writeFile(wb, "Paid-and-Pending-Payments-Report-" + Date.now() + ".xlsx");
    },
    exportToPdf() {
      const jsonData = this.paymentSettlements;
      const pdf = new jsPDF();
      pdf.setProperties({
        title: "Export to PDF",
        subject: "Paid and Pending Payments Report",
        author: "Co-Op Bank",
        keywords: "vue, pdf, export",
      });

      // Set table headers
      const headers = Object.keys(jsonData[0]);
      // Customize table options
      const tableOptions = {
        startY: 20, // Set the starting y-coordinate for the table
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        styles: {
          fontSize: 12,
        }, //season  eslipNumber status.statusName eslipAmount organizationName username phonenumber outgoingEmain
        columnStyles: {
          // Set specific column width
          season: { columnWidth: 40 },
          eslipNumber: { columnWidth: 20 },
          statusName: { columnWidth: "auto" },
          eslipAmount: { columnWidth: 40 },
          organizationName: { columnWidth: 20 },
          username: { columnWidth: "auto" },
          phonenumber: { columnWidth: 20 },
          outgoingEmain: { columnWidth: "auto" },
        },
        headStyles: {
          fillColor: [200, 200, 200], // Header background color
        },
      };
      // Set page layout options
      const layoutOptions = {
        orientation: "l", // Portrait (default)
        unit: "mm", // Measurement unit (default is "mm")
        format: "a4", // Page format ("a4", "letter", etc.)
        compress: true, // Enable PDF compression
      };
      // Auto-generate table from JSON data
      pdf.autoTable({
        head: [headers],
        body: jsonData.map((row) => headers.map((header) => row[header])),
        ...tableOptions,
      });

      // Save the PDF file
      pdf.save("exported-pdf.pdf");
    }
    ,
    displayTableReport() {
      this.showTranType = true;
    },
    pointClickHandler(e) {
      const arg = e.target;
      this.segmentSelected =arg.data.trantype;
        this.childComponentKey += 1;
        this.displayTableReport();
    },
    legendClickHandler(e) {},
    getPaymentsDetails() {
      const token = localStorage.getItem("token");
      const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
      const url = config.serverURI + "/reports/findAllPayments";
      axios
        .get(url, { tokenconfig })
        .then((response) => {
          this.paymentSettlements = response.data;

          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].status.statusName.trim() === "PAID") {
              this.paidTxns++;
            }
            if (response.data[i].status.statusName.trim() === "FAILED_SETTLEMENT") {
              this.failedTxns++;
            }
            if (response.data[i].status.statusName.trim() === "PENDING-PAYMENT") {
              this.pendingTxns++;
            }
            if (response.data[i].status.statusName.trim() === "PARTIALLY-PAID") {
              this.pendingTxns++;
            }
          }
          this.transactions = [
            {
              transaction: "Paid Transactions",
              eslip: this.paidTxns,
              trantype: "PAID",
            },
            {
              transaction: "Pending Transactions",
              eslip: this.pendingTxns,
              trantype: "PENDING",
            },
            {
              transaction: "Failed Transactions",
              eslip: this.failedTxns,
              trantype: "FAILED",
            },
          ];
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.message = error.response.status;
          this.snackbar = true;
          this.snackbarColor = "error";
        });
      return this.growersWithoutSettlement;
    },
  },
};
</script>
<style>
.right-aligned-chart {
  float: right;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}
.right-aligned-chart-item {
  float: center;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}

</style>
